import { createSelector } from '@reduxjs/toolkit';
import { initialState } from './reducer';
import { REDUCER_KEY } from './constants';

/**
 * Direct selector to the memberDetail state domain
 */

const selectMemberDetailDomain = state => state[REDUCER_KEY] || initialState;

/**
 * Other specific selectors
 */

/**
 * Default selector used by MemberDetail
 */

const makeSelectMemberDetail = () =>
  createSelector(selectMemberDetailDomain, substate => substate);

const selectMember = createSelector(
  selectMemberDetailDomain,
  substate => substate.member,
);

const selectLoadingState = createSelector(
  selectMemberDetailDomain,
  substate => substate.loadingState,
);

const makeSelectTshirtSize = () =>
  createSelector([selectMember], member =>
    member ? member.tshirtSize : 'Not verified',
  );

const makeSelectTags = () =>
  createSelector([selectMember], member => (member ? member.tags : []));

const selectAdditionalInfo = createSelector([selectMember], member =>
  member
    ? {
        gender: member.gender,
        birthday: member.birthday,
        registeredDate: member.registeredDate,
        type: member.type,
        teamBibNumber: member.team?.bibNumber,
        bibNumber: member.bibNumber,
        meal: member.meal,
        hostingEntryId: member.team?.hostingEntryId,
        boardingStatus: member.boardingStatus,
        source: member.source,
        previousParticipation: member.previousParticipation,
        capNeeded: member.needCap,
        bikeOrders: (member.orders ?? []).filter(o => o.product === 'bike'),
        bikeNeeded: (member.orders ?? []).some(o => o.product === 'bike'),
        hasFTTRILicense: member.hasFttriLicense,
        group: member.team?.group,
        coupon: member.team?.coupon,
        teamId: member.team?.id,
        documents: member.documents,
        status: member.status,
      }
    : {},
);

export const selectBikeOrderState = createSelector(
  selectMemberDetailDomain,
  substate => substate.bikeOrderState,
);

const makeSelectMemberTshirtState = () =>
  createSelector(
    selectMemberDetailDomain,
    substate => substate.memberTshirtState,
  );
const makeSelectMealUpdateState = () =>
  createSelector(
    selectMemberDetailDomain,
    substate => substate.mealUpdateState,
  );

export const selectAssignGroupState = createSelector(
  selectMemberDetailDomain,
  substate => substate.assignGroup,
);

export const selectMemberTeamId = createSelector(
  [selectMember],
  member => member?.team?.id || null,
);

const makeSelectMealAction = () =>
  createSelector(selectMemberDetailDomain, substate => substate.mealAction);
export default makeSelectMemberDetail;
export {
  selectMemberDetailDomain,
  selectMember,
  selectLoadingState,
  makeSelectMemberTshirtState,
  selectAdditionalInfo,
  makeSelectTshirtSize,
  makeSelectTags,
  makeSelectMealUpdateState,
  makeSelectMealAction,
};
